//
//
//
//
//
//
//

const COMPONENT_NAME = 'cube-loading'
export default {
  name: COMPONENT_NAME,
  data() {
    return {
      balde: 12
    }
  },
  props: {
    size: {
      type: Number
    }
  },
  computed: {
    style() {
      if (!this.size) {
        return
      }
      const value = `${this.size}px`
      return {
        width: value,
        height: value
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/image-preview/src/loading/loading.vue